



















































































import { Vue, Component, State, namespace, Prop, Inject } from 'nuxt-property-decorator'
import dayjs from 'dayjs'
import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component
export default class ExperienceDate extends Vue {
  @State klook!: Data.Klook
  @State(state => state.klook.platform) platform!: Data.Platform
  @experience.Action setUrlQuery!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State searchStartTime!: []
  @Prop({ default: true }) showReset!: boolean
  @Inject({ default: (_: any) => _ }) resetPage!: Function
  date: Date | null = null
  current: number = -1

  get maxDate() {
    if (this.searchStartTime && this.searchStartTime.length > 0) {
      const date = this.searchStartTime[this.searchStartTime.length - 1]
      return new Date(date)
    }
    return new Date()
  }

  get isDesktop() {
    return this.platform === 'desktop'
  }

  changeDate(index: number) {
    this.current = index
    if (index === -1) {
      this.date = null
      return null
    }
    const d = new Date()
    this.date = index === 0 ? d : new Date(d.setDate(d.getDate() + 1))
  }

  hide() {
    this.$emit('hide')
  }

  onChange(date: any) {
    if (!date) {
      this.$emit('change', '')
      return null
    }
    if (this.date) {
      const utcDate = new Date(
        Date.UTC(
          this.date.getFullYear(),
          this.date.getMonth(),
          this.date.getDate()
        )
      ).toISOString()
      this.$emit('change', utcDate)
    }
    const d = new Date()
    const today = dayjs(d).format('YYYY-MM-DD')
    const tomorrow = dayjs(new Date(d.setDate(d.getDate() + 1))).format(
      'YYYY-MM-DD'
    )
    const chosenDate = dayjs(date).format('YYYY-MM-DD')
    if (chosenDate === today) {
      this.current = 0
    } else if (chosenDate === tomorrow) {
      this.current = 1
    } else {
      this.current = 2
    }
  }

  reset() {
    this.date = null
    this.current = -1
  }

  submit() {
    let date = '-'
    if (this.date) {
      const utcDate = new Date(
        Date.UTC(
          this.date.getFullYear(),
          this.date.getMonth(),
          this.date.getDate()
        )
      )
      date = utcDate.toISOString()
      this.resetPage && this.resetPage()
      this.setUrlQuery({
        start_date: utcDate.toISOString(),
        page: 1
      })
    } else {
      this.resetPage && this.resetPage()
      this.setUrlQuery({
        start_date: '',
        page: 1
      })
    }

    try {
      const submitButton = (this.$refs.submitButton as Vue).$el
      if (submitButton) {
        this.$inhouse.updateBinding(submitButton, {
          ext: {
            Date: date
          }
        })
        this.$inhouse.track('action', submitButton)
      }
    } catch (e) {}

    const a = setTimeout(() => {
      this.hide()
      clearTimeout(a)
    })
  }

  mounted() {
    if (this.urlQuery.start_date) {
      this.date = new Date(this.urlQuery.start_date)
    }
  }
}
